'use client'

import { useContext } from 'react'

import camelCase from 'lodash/fp/camelCase'
import isEmpty from 'lodash/fp/isEmpty'
import snakeCase from 'lodash/fp/snakeCase'

import type { FeatureFlagsContext as FeatureFlagsContextValue } from '../types'

import { FeatureFlagsContext } from '../contexts/FeatureFlagsContext'

export default function useFeatureFlags(flag?: string) {
  const featureFlagsContext =
    useContext<FeatureFlagsContextValue>(FeatureFlagsContext)

  const featureFlags = {
    ...featureFlagsContext,
    ...Object.fromEntries(
      Object.entries(featureFlagsContext).map(([key, value]) => [
        camelCase(key),
        value,
      ]),
    ),
    ...Object.fromEntries(
      Object.entries(featureFlagsContext).map(([key, value]) => [
        snakeCase(key),
        value,
      ]),
    ),
  }

  return isEmpty(flag) ? featureFlags : featureFlags[flag]
}
